<template>
  <div>
    <div class="notifi-container">
      <div class="d-flex card-container">
        <div class="pa-4">
          <v-icon class="icon-alert-triangle"></v-icon>
        </div>
        <div class="py-3 pr-3 text-left">
          <div class="title-card mb-6">
            SMS OTP is required for resetting TOTP.
          </div>
          <div>
            Your phone number has not been registered, please contact your Administrator for support.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../../router";

export default Vue.extend({
  name: "NoPhoneNumber",
  components: {
  },
  methods: {
    backToLogin() {
      router.push("/login");
    }
  }
})
</script>

<style lang="scss" scoped>
.notifi-container {
  margin-top: 120px;
}
.card-container {
  width: 100%;
  max-width: 320px;
  background: #F9ECD1;
  margin: 0 auto;

  .title-card {
    color: #AC6600;
  }
}
</style>